import { GenericError, LoadingSpinner } from '@psyomics/ui-components';
import { Navigate, useParams } from 'react-router-dom';

import { ReferralRequestStatus } from '../../../features/referral-request/generated/referral-request';
import { useReferralRequest } from '../../../features/referral-request/hooks/use-referral-request';
import { useReferralRequestService } from '../../../features/referral-request/hooks/use-referral-request-service';
import { ReferralRequestView as ReferralRequestViewFeature } from '../../../features/referral-request/referral-request-view';

const useReferralRequestViewData = () => {
  const { id } = useParams<{ id: string }>();
  const { referralRequest, fetching: fetchingReferralRequest } = useReferralRequest(
    id ?? '',
    ReferralRequestStatus.Submitted
  );
  const { service, fetching: fetchingService } = useReferralRequestService(
    referralRequest?.organisationCode ?? '',
    referralRequest?.serviceCode ?? ''
  );

  return { referralRequest, fetching: fetchingReferralRequest || fetchingService, id, service };
};

const ReferralRequestView = () => {
  const { referralRequest, fetching, id, service } = useReferralRequestViewData();

  if (!id) return <Navigate to="/" />;
  if (fetching) return <LoadingSpinner />;
  if (!referralRequest || !service) return <GenericError titleKey="common.errors.notFound" />;

  return <ReferralRequestViewFeature id={id} referralRequest={referralRequest} service={service} />;
};

export { ReferralRequestView };
